import Image01 from './memes/01.jpg';
import Image02 from './memes/02.jpg';
import Image03 from './memes/03.jpg';
import Image04 from './memes/04.jpg';
import Image05 from './memes/05.jpg';
import Image06 from './memes/06.jpg';
import Image07 from './memes/07.jpg';
import Image08 from './memes/08.jpg';
import Image09 from './memes/09.jpg';
import Image10 from './memes/10.jpg';
import Image11 from './memes/11.jpg';
import Image12 from './memes/12.jpg';
import Image13 from './memes/13.jpg';
import Image14 from './memes/14.jpg';
import Image15 from './memes/15.jpg';
import Image16 from './memes/16.jpg';
import Image17 from './memes/17.jpg';
import Image18 from './memes/18.jpg';

const Images = [Image01, Image02, Image03, Image04, Image05, Image06, Image07, Image08, Image09, Image10, Image11, Image12, Image13, Image14, Image15, Image16, Image17, Image18];
export default Images;